import styled from 'styled-components';
import { Form, InputGroup as BootstrapInputGroup } from 'react-bootstrap';

const TableHeader = styled.div`
  container-type: inline-size;
  display: flex;
  flex-wrap: wrap;
  gap: 16px 20px;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  margin-bottom: 0;
  background-color: transparent;
  border-bottom: 2px solid #e9ecef;
`;

const TableHeaderContent = styled.div`
  display: flex;
  flex: 1;
  min-width: min(480px, 100%);
  flex-direction: column;
  gap: 8px;
`;

const TableHeaderActions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;

  @container (min-width: 360px) {
    flex-direction: row;
  }

  @container (min-width: 480px) {
    width: auto;
    flex-shrink: 0;
  }
`;

const TableRow = styled.tr`
  cursor: ${({ clicable }) => (clicable ? 'pointer' : 'auto')};
`;

const TableTitle = styled.h2`
  margin-bottom: 0;
`;

const TableSubtitle = styled.p`
  margin-bottom: 0;
  color: #6c757d;
  font-size: 13px;
`;

const EmptyStateTitle = styled.p`
  max-width: 800px;
  margin: 1rem 0 0;
  color: #6c757d;
  font-size: 13px;
  font-weight: bold;
  text-align: center;
`;

const EmptyStateDescription = styled.p`
  max-width: 800px;
  margin: 0;
  color: #6c757d;
  font-size: 13px;
  text-align: center;
`;

const InputGroup = styled(BootstrapInputGroup)`
  max-width: 250px;
  height: 40px;
  border: 1px solid #e2ebf6 !important;
  ${({ active }) => active && `border: 1px solid #2c7be5 !important;`}
  border-radius: 0.375rem;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;

  input {
    border: none !important;
  }
`;

const Icon = styled(BootstrapInputGroup.Text)`
  margin-right: -5px;
  border: none;
`;

const Input = styled(Form.Control)`
  bord<er-left-width: 0;
  padding: 0 0 0 0.5rem !important;
  min-height: 1px !important;
  &:focus {
    border-color: #d2ddec !important;
  }
`;

export {
  TableHeader,
  TableTitle,
  TableSubtitle,
  TableHeaderContent,
  TableHeaderActions,
  EmptyStateTitle,
  EmptyStateDescription,
  InputGroup,
  Icon,
  Input,
  TableRow,
};
